<@if (dashLiberada) {
<main class="home">
  <div class="container">
    @if (eleicaoHabilitadoAuto && temEleicao && podeVotarFusan) {
      <div class="card mb-5 panel-eleicoes" style="margin-bottom: 10px;">
        <div class="card-header" style="text-align: center">
          <h5><img src="../../../../../assets/img/politica.png" style="width: 24px; display: inline; padding-right: 6px;">Eleições</h5>
        </div>
        <div class="card-body col-md-12">
          @if (eleicaoFusanMsg!='') {
            <div class="alert alert-warning col-md-12">
              <div class="col-md-1"><i class="glyphicon glyphicon-info-sign" style="font-size: 34px"></i></div>
              <div style="margin-top: 7px"><span></span>{{eleicaoFusanMsg}}</div>
            </div>
          }
          <div  class="col-md-12 text-center">
            <a [class.disabled]="eleicaoFusan.indexOf('https://') == -1" id="eleicaofus" class="btn btn-primary" title="Votar" [href]="eleicaoFusan" target="_blank" style="color: white; width: 271px; background-color: #007bff; cursor: pointer;">
              <img src="../../../../../assets/img/voto_2.png" style="width: 20px; display: inline;">
              Votar Eleições Fusan
            </a>
          </div>
        </div>
      </div>
    }
    <div class="row home-header mb-2 mb-lg-4">
      <div class="col general-title">
        <h2>Bem-vindo(a)! <small>Última atualização: {{dataUltimaAtualizacao | date:"dd/MM/yyyy"}}</small></h2>
        <p>Painel de informações sobre seu plano Viva Mais Previdência - CNPB: 2019002574.</p>
      </div>
      <div class="col-auto text-align-right mt-4 mt-lg-0">
        <ul class="list-inline pl-0 pl-lg-5 list-extract">
          <li class="list-inline-item m-0 px-3 pl-0 pl-lg-4 px-lg-4 mb-3 mb-lg-0">
            <p class="small">Entrada</p>
            <p class="font-weight-bold red">{{saldoEntrada| currency:'R$'}}</p>
          </li>
          <li class="list-inline-item m-0 px-3 pl-0 pl-lg-4 px-lg-4 mb-3 mb-lg-0">
            <p class="small">Saída</p>
            <p class="font-weight-bold green">{{saldoSaida| currency:'R$'}}</p>
          </li>
          <li class="list-inline-item m-0 px-3 pl-0 pl-lg-4 px-lg-4 mb-3 mb-lg-0">
            <p class="small">Rendimento</p>
            <p class="font-weight-bold red">R$ {{saldoRentabilidade| number:'1.2-2'}}</p>
          </li>
          <li class="list-inline-item m-0 px-3 pl-0 pl-lg-4 px-lg-4 mb-3 mb-lg-0">
            <p class="small">Saldo Total</p>
            <p class="font-weight-bold green">{{saldoFinal| currency:'R$'}}</p>
          </li>
          <li class="list-inline-item m-0 px-3 pl-0 pl-lg-4 px-lg-4 mb-3 mb-lg-0">
            <p class="small">Contrib. Mensal</p>
            <p class="font-weight-bold red">{{valorContribuicao| currency:'R$'}}</p>
          </li>
        </ul>
      </div>
    </div>
    <div class="row mb-30">
      <div class="col-12 col-lg-9 mb-3 mb-lg-0">
        <app-grafico class="box"></app-grafico>
      </div>
      <!--Banner lado direito condicional a quem é elegível ao seguro-->
      @if (elegivelSeguro==1 && exibeBannerSeguro) {
        <div class="col-12 col-lg-3">
          <div class="box w-100 boxcolor1">
            <div class="center">
              <div class="title">Contrate agora uma cobertura adicional</div>
              <a routerLink="/logado/seguro-adesao" class="btn btn-light blue">Simule o seguro ideal</a>
            </div>
          </div>
        </div>
      }
      <!--Banner lado direito condicional a quem não é elegível ao seguro-->
      @if (elegivelSeguro==0 || !exibeBannerSeguro) {
        <div class="col-12 col-lg-3">
          <div class="box w-100 boxcolor5">
            <div class="center">
              <div class="title">Programe o seu futuro</div>
              <p>afinal você conhece o <br> tamanho dos seus objetivos.</p>
              <a href="https://simulador.fundacoesnet.com.br/simulador-projeto-futuro-viva-mais-previdencia" target="_blank" class="btn btn-light blue">Simule seus sonhos</a>
            </div>
          </div>
        </div>
      }
    </div>
    <div class="row mb-30">
      <div class="col-12 col-lg-3 mb-3 mb-lg-0">
        <div class="box w-100 boxcolor2">
          <div class="center">
            <div class="title">Invista <br> <span>no seu futuro</span></div>
            <a href="#aporte"
              class="btn btn-light green"
              data-toggle="modal"
              data-target="#homeModal"
              (click)="modalType = 'aporte'"
              (click)="modalStep = 'aporte_1'"
              >
              Faça um aporte <br> no seu plano
            </a>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-3 mb-3 mb-lg-0">
        <div class="box w-100 boxcolor3">
          <div class="center">
            <div class="title">Não perca <br> <span>tempo</span></div>
            <a href="#contrib" class="btn btn-light blue" data-toggle="modal" data-target="#homeModal"
              (click)="modalType = 'contrib'"
              (click)="modalStep = 'contrib_1'">
              Aumente sua <br> contribuição mensal
            </a>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-3 mb-3 mb-lg-0">
        <div class="box w-100 boxcolor4">
          <div class="center">
            <div class="title">Multiplique <br> <span>sua rentabilidade</span></div>
            <a href="#portab"
              class="btn btn-light green"
              data-toggle="modal"
              data-target="#homeModal"
              (click)="modalType = 'portab'"
              >
              Faça uma portabilidade <br> agora mesmo
            </a>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-3">
        <div class="box movlist" routerLink="/logado/financeiro/recebimentos" style="cursor: pointer;">
          <div class="head">
            <h4>Recebimentos</h4> <a routerLink="/logado/financeiro/recebimentos">Ver todos</a>
          </div>
          <div class="body">
            <ul>
              @for (item of cobrancas; track item) {
                <li>
                  <div>
                    <i class="fas fa-print mr-3"></i>
                    <div>
                      <div class="date">{{item.DTA_VENC| date:'dd/MM/yyyy'}}</div>
                      <div class="{{item.CLASSE}}"><i class="fas fa-circle"></i> {{item. DCR_COB_STATUS_EXT}}</div>
                    </div>
                  </div>
                  <div class="value">{{item.VLR_VENC | currency:'R$'}}</div>
                </li>
              }
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade" id="homeModal">
    <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered">
      <div class="modal-content">
        <button type="button" class="close" data-dismiss="modal" (click)="closeModal(modalType)">
          <i class="fas fa-times"></i>
        </button>
        <div class="modal-body">
          <div class="loading">
            <i class="fas fa-spin fa-spinner"></i>
          </div>
          @if (modalType == 'aporte') {
            <div>
              @if (modalType == 'aporte') {
                <app-aporte></app-aporte>
              }
            </div>
          }
          @if (modalType == 'contrib') {
            <div>
              <app-contribuicao #contribuicao></app-contribuicao>
            </div>
          }
          @if (modalType == 'portab') {
            <div>
              @if (modalType == 'portab') {
                <app-portabilidade></app-portabilidade>
              }
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</main>
}>
